import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

// import useSignup from '@src/hooks/auth/signup/useSignup'
import useSignupContext from '@src/hooks/auth/signup/useSignupContext'

import Input from '@src/components/inputs/Input'
import FileSelector from '@src/components/inputs/FileSelector'
import Textarea from '@src/components/inputs/Textarea'

const BrandInfoSection = () => {
	const { getFieldProps, getFileFieldProps, brandLogoData } = useSignupContext()

	return (
		<>
			<FileBlock>
				<FileSelector
					{...getFileFieldProps('profileImg', 'brandLogo')}
					accept="image/*"
					label={
						<BrandLogoLabelBlock>
							<BrandLogoLabel>브랜드 로고</BrandLogoLabel>
							<BrandLogoSizeGuied>(1:1 비율)</BrandLogoSizeGuied>
						</BrandLogoLabelBlock>
					}
					buttonTxt={brandLogoData ? '변경' : '업로드'}
				/>

				{brandLogoData && (
					<ImageBlock>
						<Image src={URL.createObjectURL(brandLogoData)} alt="브랜드 로고 이미지" />
					</ImageBlock>
				)}
			</FileBlock>
			<Input
				{...getFieldProps('name')}
				css={inputStyle}
				label="브랜드명"
				placeholder="브랜드명을 입력해주세요."
			/>
			<Input
				{...getFieldProps('vendorStoreLink')}
				css={inputStyle}
				label="사이트 URL"
				placeholder="사이트 URL을 입력해주세요."
			/>
			<CompanyIntroTextarea
				{...getFieldProps('companyDescription')}
				label="브랜드 한줄 소개"
				placeholder="기업 소개글을 입력해주세요."
				rows={2}
				cols={48}
			/>
		</>
	)
}

const inputStyle = css`
	width: 27rem;
`

const FileBlock = styled.div`
	display: flex;
	align-items: center;
`

const ImageBlock = styled.div`
	width: 10rem;
	height: 10rem;
	margin-left: 1rem;
	border-radius: 50%;
	overflow: hidden;
`

const Image = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

const CompanyIntroTextarea = styled(Textarea)`
	resize: none;
	padding: 0.5rem 1.1rem;
	overflow: hidden;
`

const BrandLogoLabelBlock = styled.div`
	display: flex;
	flex-direction: column;
`

const BrandLogoLabel = styled.span``

const BrandLogoSizeGuied = styled.span`
	font-family: Pretendard;
	font-size: 1.2rem;
	font-weight: 500;
`

export default BrandInfoSection
